import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import InstallWebPackageManagers from "./install-web-package-managers.mdx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Install `}<inlineCode parentName="p">{`posthog-js`}</inlineCode>{` using your package manager:`}</p>

    <InstallWebPackageManagers mdxType="InstallWebPackageManagers" />
    <p>{`Then, if you haven't created a root `}<a parentName="p" {...{
        "href": "https://kit.svelte.dev/docs/routing#layout"
      }}>{`layout`}</a>{` already, create a new file called `}<inlineCode parentName="p">{`+layout.js`}</inlineCode>{` in your `}<inlineCode parentName="p">{`src/routes`}</inlineCode>{` folder In this file, check the environment is the browser, and initialize PostHog if so. You can get both your API key and instance address in your `}<a parentName="p" {...{
        "href": "https://us.posthog.com/project/settings"
      }}>{`project settings`}</a>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js",
        "metastring": "file=routes/+layout.js",
        "file": "routes/+layout.js"
      }}>{`import posthog from 'posthog-js'
import { browser } from '$app/environment';

export const load = async () => {
  if (browser) {
    posthog.init('<ph_project_api_key>', {
      api_host: '<ph_client_api_host>',
      defaults: '<ph_posthog_js_defaults>',
    })
  }

  return
};
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      